/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function MathTeX({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M7.842 2.896a.4.4 0 0 1 .386-.296H15a.6.6 0 1 0 0-1.2H8.228a1.6 1.6 0 0 0-1.545 1.184l-2.48 9.21-1.012-3.419a.6.6 0 0 0-.576-.43H1a.6.6 0 0 0 0 1.2h1.167l1.488 5.025a.6.6 0 0 0 1.155-.014z" /><path fill="currentColor" d="M9.424 6.576a.6.6 0 0 0-.848.848L10.652 9.5l-2.076 2.076a.6.6 0 1 0 .848.848L11.5 10.35l2.076 2.075a.6.6 0 0 0 .848-.848L12.35 9.5l2.075-2.076a.6.6 0 0 0-.848-.848L11.5 8.652z" /></svg>;
}
;